import { Button, Spacer, Text } from '@truepill/react-capsule'
import { useMutation } from '@truepill/tpos-react-router'
import { CONFIRM_FILL_PV1 } from 'gql'
import useErrorToast from 'hooks/toast/useErrorToast'
import useAnalytics from 'hooks/useAnalytics'
import useGetNextPV1 from 'hooks/useGetNextPV1'
import { useToastContext } from 'providers/Overlays/ToastProvider'
import { CheckCircle } from 'react-feather'
import { PV1Events } from 'services/analytics/events/pv1Events'
import { ToastType, type Fill, type Order } from 'types'

const useConfirmPV1 = (order: Order, fill: Fill) => {
  const [confirmFillPV1] = useMutation(CONFIRM_FILL_PV1, { refetchQueries: ['getBasicOrder'] })
  const { getNextPV1 } = useGetNextPV1()
  const { trackPV1Event } = useAnalytics()
  const { showToast } = useToastContext()
  const showErrorToast = useErrorToast()

  return async () => {
    try {
      if (order?.inTriage) {
        throw new Error('Unable to confirm a fill while it is in Triage')
      }
      await confirmFillPV1({
        variables: {
          orderId: order._id,
          fillId: fill._id,
        },
      })
      const rxFillRequest = order?.rxFillRequests.find(rxFillRequest => rxFillRequest.fillId === fill._id)
      showToast(
        `Rx: ${fill?._id} ${rxFillRequest?.status && '- ' + rxFillRequest?.status + ' '} confirmed`,
        ToastType.success,
      )
      trackPV1Event(PV1Events.PV1_END.key, { fillId: fill._id })
      await getNextPV1(order, fill)
    } catch (error) {
      showErrorToast('Failed to confirm PV1: ' + (error as Error)?.message)
    }
  }
}

const ConfirmButton = ({ order, fill }: { order: Order; fill: Fill }) => {
  const confirmPV1 = useConfirmPV1(order, fill)

  return (
    <Button
      size="sm"
      variant="primary"
      style={{ display: 'flex', alignItems: 'center', marginLeft: '0.5em' }}
      data-testid="confirm"
      onClick={confirmPV1}
    >
      <CheckCircle aria-hidden />
      <Spacer size="xs" />
      <Text>Confirm</Text>
    </Button>
  )
}

export default ConfirmButton
